import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';
import { relativeTo } from '@/integrations/tanstack-router/relative-to';

const P360 = '/patient-360' as const;
const P360_PATIENT = `${P360}/$patientId` as const;
const P360_IP = `${P360_PATIENT}/inpatient-info` as const;
const P360_VS = `${P360_PATIENT}/vital-signs` as const;

const examReports = `${P360_PATIENT}/exam-reports` as const;
const imagingReports = `${P360_PATIENT}/imaging-reports` as const;
const pathologyReports = `${P360_PATIENT}/pathology-reports` as const;
const surgeryReports = `${P360_PATIENT}/surgery-reports` as const;

export const PATIENT_360_ROUTES = {
  index: P360,
  patientView: P360_PATIENT,
  visits: `${P360_PATIENT}/visits`,
  labReports: `${P360_PATIENT}/lab-reports`,
  labReportDateGroup: `${P360_PATIENT}/lab-reports/date-group`,
  labReportCategoryGroup: `${P360_PATIENT}/lab-reports/category-group`,
  imagingReports,
  imagingReport: `${imagingReports}/report`,
  examReports,
  examReport: `${examReports}/report`,
  pathologyReports,
  pathologyReport: `${pathologyReports}/report`,
  surgeryReports,
  surgeryReport: `${surgeryReports}/report`,
  vitalSigns: `${P360_PATIENT}/vital-signs`,
  vaccinations: `${P360_PATIENT}/vaccinations`,
  diagnosisCertificates: `${P360_PATIENT}/diagnosis-certificates`,
  medications: `${P360_PATIENT}/medications`,
  chronicDisease: `${P360_PATIENT}/chronic-disease`,
  cloudPharmacy: `${P360_PATIENT}/cloud-pharmacy`,
  outpatientInfo: `${P360_PATIENT}/outpatient-info`,
  reportContent: `${P360_PATIENT}/report-content`,
} as const;

export const INPATIENT_INFO_ROUTES = {
  inpatientInfo: P360_IP,
  reportContent: `${P360_IP}/report-content`,
  dischargeMedications: `${P360_IP}/discharge-medications`,
  dischargeNote: `${P360_IP}/discharge-note`,
  surgeryRecords: `${P360_IP}/surgery-records`,
  labReports: `${P360_IP}/lab-reports`,
  labReportDateGroup: `${P360_IP}/lab-reports/date-group`,
  labReportCategoryGroup: `${P360_IP}/lab-reports/category-group`,
  imagingReports: `${P360_IP}/imaging-reports`,
  examReports: `${P360_IP}/exam-reports`,
  pathologyReports: `${P360_IP}/pathology-reports`,
  admissionNote: `${P360_IP}/admission-note`,
  progressNotes: `${P360_IP}/progress-notes`,
  nursingNotes: `${P360_IP}/nursing-notes`,
  orders: `${P360_IP}/orders`,
  tpr: `${P360_IP}/tpr`,
} as const;

export const VITAL_SIGNS_ROUTES = {
  index: P360_VS,
  detail: `${P360_VS}/$type`,
} as const;

export const PATIENT_360_VIEW_ROUTE_ID =
  `/${AUTH_ROUTE_ID}${PATIENT_360_ROUTES.patientView}` as const;

export const PATIENT_360_ROUTE_IDS = {
  index: `/${AUTH_ROUTE_ID}${PATIENT_360_ROUTES.index}`,
  visits: `${PATIENT_360_VIEW_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.visits, PATIENT_360_ROUTES.patientView)}`,
  outpatientInfo: `${PATIENT_360_VIEW_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.outpatientInfo, PATIENT_360_ROUTES.patientView)}`,
  vaccinations: `${PATIENT_360_VIEW_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.vaccinations, PATIENT_360_ROUTES.patientView)}`,
  diagnosisCertificates: `${PATIENT_360_VIEW_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.diagnosisCertificates, PATIENT_360_ROUTES.patientView)}`,
  medications: `${PATIENT_360_VIEW_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.medications, PATIENT_360_ROUTES.patientView)}`,
  chronicDisease: `${PATIENT_360_VIEW_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.chronicDisease, PATIENT_360_ROUTES.patientView)}`,
  cloudPharmacy: `${PATIENT_360_VIEW_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.cloudPharmacy, PATIENT_360_ROUTES.patientView)}`,
} as const;

export const REPORT_LAYOUT_ROUTE_ID = 'patient-360-report-layout' as const;
export const REPORT_LAYOUT_FULL_ROUTE_ID =
  `${PATIENT_360_VIEW_ROUTE_ID}/${REPORT_LAYOUT_ROUTE_ID}` as const;

export const REPORT_ROUTE_IDS = {
  labReports: `${REPORT_LAYOUT_FULL_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.labReports, PATIENT_360_ROUTES.patientView)}`,
  imagingReports: `${REPORT_LAYOUT_FULL_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.imagingReports, PATIENT_360_ROUTES.patientView)}`,
  examReports: `${REPORT_LAYOUT_FULL_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.examReports, PATIENT_360_ROUTES.patientView)}`,
  surgeryReports: `${REPORT_LAYOUT_FULL_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.surgeryReports, PATIENT_360_ROUTES.patientView)}`,
  pathologyReports: `${REPORT_LAYOUT_FULL_ROUTE_ID}${relativeTo(PATIENT_360_ROUTES.pathologyReports, PATIENT_360_ROUTES.patientView)}`,
} as const;

export const INPATIENT_INFO_LAYOUT_ROUTE_ID = 'inpatient-info-layout' as const;
export const INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID =
  `${PATIENT_360_VIEW_ROUTE_ID}/${INPATIENT_INFO_LAYOUT_ROUTE_ID}` as const;

export const INPATIENT_INFO_ROUTE_IDS = {
  inpatientInfo: `${INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID}${relativeTo(INPATIENT_INFO_ROUTES.inpatientInfo, PATIENT_360_ROUTES.patientView)}`,
  surgeryRecords: `${INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID}${relativeTo(INPATIENT_INFO_ROUTES.surgeryRecords, PATIENT_360_ROUTES.patientView)}`,
  labReports: `${INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID}${relativeTo(INPATIENT_INFO_ROUTES.labReports, PATIENT_360_ROUTES.patientView)}`,
  imagingReports: `${INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID}${relativeTo(INPATIENT_INFO_ROUTES.imagingReports, PATIENT_360_ROUTES.patientView)}`,
  examReports: `${INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID}${relativeTo(INPATIENT_INFO_ROUTES.examReports, PATIENT_360_ROUTES.patientView)}`,
  pathologyReports: `${INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID}${relativeTo(INPATIENT_INFO_ROUTES.pathologyReports, PATIENT_360_ROUTES.patientView)}`,
  tpr: `${INPATIENT_INFO_LAYOUT_FULL_ROUTE_ID}${relativeTo(INPATIENT_INFO_ROUTES.tpr, PATIENT_360_ROUTES.patientView)}`,
} as const;

export const VITAL_SIGNS_LAYOUT_ROUTE_ID = 'vital-signs-layout' as const;
export const VITAL_SIGNS_LAYOUT_FULL_ROUTE_ID =
  `${PATIENT_360_VIEW_ROUTE_ID}/${VITAL_SIGNS_LAYOUT_ROUTE_ID}` as const;

export const VITAL_SIGNS_ROUTE_IDS = {
  index: `${VITAL_SIGNS_LAYOUT_FULL_ROUTE_ID}${relativeTo(VITAL_SIGNS_ROUTES.index, PATIENT_360_ROUTES.patientView)}`,
  detail: `${VITAL_SIGNS_LAYOUT_FULL_ROUTE_ID}${relativeTo(VITAL_SIGNS_ROUTES.detail, PATIENT_360_ROUTES.patientView)}`,
} as const;
